import React, { useEffect, useMemo, useState } from "react";
import {
  Radio,
  FormItem,
  FormButtonGroup,
  Submit,
  Input,
  Select,
  Space,
  FormDialog,
  NumberPicker,
} from "@formily/antd";
import { createForm, onFieldReact, onFieldValueChange } from "@formily/core";
import { FormProvider, Field, VoidField } from "@formily/react";
import { Button, Card, Modal, Table } from "antd";
import { useHistory } from "react-router-dom";
import { request, requestkind } from "../../unit/request";
import { DownloadKind, downloadStaticFile } from "../../unit/download";
import json2form from "../../unit/json2form";
import * as datasource from "../../conf/datasource";
import { ExcelUpload } from "../../components/upload";
import { CreditSummary } from "../../components/Summary";
import { max } from "moment";

export default function ApplyPost() {
  const history = useHistory();
  const [errs, setErrs] = useState<any>({});
  const [showErr, setShowErr] = useState(false);
  const [partnerNumber, setPartnerNumber] = useState<string>();
  //进入页面，先获得当前的ParterInfo
  const getCurrentParterInfo = async () => {
    console.log("getting...");
    const json = await request(
      null,
      null,
      requestkind.Partner.CurrentParterInfo
    );
    const { PartnerNumber, PartnerName } = json.Data;
    console.log(json, PartnerNumber, PartnerName);
    if (PartnerNumber) {
      form.setFieldState("PartnerNumber", (state) => {
        state.value = PartnerNumber;
      });
    }
    form.setFieldState("PartnerName", (state) => {
      state.value = PartnerName;
    });
    setPartnerNumber(PartnerNumber);
  };
  useEffect(() => {
    getCurrentParterInfo();
  }, []);

  //1、检测
  const verify = async (formdata: FormData): Promise<boolean> => {
    console.log("ApplyVerify...", formdata);
    const json = await request(
      formdata,
      null,
      requestkind.CreditApply.ApplyVerify
    );
    console.log(json);
    const { IsSuccess, Msg, Data, errors } = json;
    if (errors) {
      setErrs(errors);
      setShowErr(true);
      return new Promise((resolve, reject) => {
        reject(false);
      });
    } else {
      const { VerifyResult, Message } = Data;
      return new Promise((resolve, reject) => {
        if (VerifyResult) {
          if (Message) {
            // 信用额度不足 弹出选项。
            Modal.confirm({
              title: Message,
              okText: "是",
              cancelText: "否",
              onOk: () => {
                resolve(true);
              },
              onCancel: () => {
                resolve(false);
              },
            });
          } else {
            resolve(true);
          }
        } else {
          Modal.warning({
            title: "提醒",
            content: Message,
          });
          // if (errors) {
          //     setErrs(errors)
          //     setShowErr(true)
          // }
          resolve(false);
        }
      });
    }
  };
  //2、提交申请
  const post = async (data: any) => {
    console.log('creditApply post button click');
    const formdata = json2form(data);
    //通过验证，则真提交
    setLoading(true);
    const flag = await verify(formdata);
    console.log('verify',flag);
    if (flag) {
      console.log("posting...", formdata);
      const json = await request(formdata, null, requestkind.CreditApply.Apply);
      console.log(json);
      
      const { IsSuccess, Msg, Data, errors } = json;
      if (IsSuccess) {
        const { FlowID } = Data;
        Modal.success({
          title: "申请成功！",
          content: `FlowID:${FlowID}`,
          onOk: () => {
            console.log("goto ");
            history.push("/creditApply");
          },
        });
      } else {
        if (Msg) {
          Modal.error({
            title: "错误！",
            content: Msg,
          });
          setLoading(false);
        }
        if (errors) {
          setErrs(errors);
          setShowErr(true);
        }
      }
    }else{
      console.log('verify return false')
      setLoading(false);
    }
  };

  const getAgreementInfo = async (agreementNumber: string) => {
    const json = await request(
      null,
      {
        agreementNumber: agreementNumber,
      },
      requestkind.Credit.GetAgreementInfo
    );
    console.log(json);
    // const { EndCustomerName, EndCustomerNumber, PartnerName, PartnerNumber, ProductType } = json.Data
    if (json.Data) {
      const { EndCustomerName, ProductType } = json.Data;
      form.setFieldState("CustomerName", (state) => {
        state.value = EndCustomerName;
      });
      form.setFieldState("ProductType", (state) => {
        state.value = ProductType;
      });
    } else {
      form.setFieldState("CustomerName", (state) => {
        state.value = "";
      });
      form.setFieldState("ProductType", (state) => {
        state.value = "";
      });
      FormDialog("错误！", () => {
        form.setFieldState("AgreementNumber", (state) => {
          state.value = "";
        });
        return (
          <p>系统不存在合约编号为{agreementNumber}的记录，请检查后重试！</p>
        );
      }).open();
    }
  };

  const form = useMemo(
    () =>
      createForm({
        effects() {
          //一对多（主动）
          //输入AgreementNumber合约编号，自动填写EndCustomerName和ProductType
          onFieldValueChange("AgreementNumber", (field) => {
            const CreateOrderType = field.query("CreateOrderType").value();
            //合约编号是13位 如：V5701312S2085
            if (
              CreateOrderType === "AdditionalOrder" &&
              field.value.trim().length === 13
            ) {
              getAgreementInfo(field.value);
            }
          });
          onFieldValueChange("CreateOrderType", (field) => {
            console.log("CreateOrderType");
            form.setFieldState("FirstYearAmount", (state) => {
              console.log("state", state);
              state.display = field.value === "1" ? "none" : "visible";
            });
            // form.setFieldState('AgreementNumber_and_TotalAmount', (state) => {
            //     console.log('state', state)
            //     state.display = field.value === "2" ? "none" : "visible"
            // })
            // form.setFieldState('AgreementNumber', (state) => {
            //     console.log('AgreementNumber state', state.required)
            //     // state.required = (field.value === "InitialOrder" ? false : true)
            //     // state.required = true
            //     // state.validator = (field.value === "InitialOrder" ? {} : { length: 13 })
            // })
            //如是初始订单，则清除合约编号和客户名称和产品
            if (field.value === "InitialOrder") {
              form.setFieldState("AgreementNumber", (state) => {
                state.value = "";
                // 强行覆盖 用feedbacks 非强行覆盖用 errors
                state.feedbacks = [];
                state.required = false;
              });
              form.setFieldState("CustomerName", (state) => {
                state.value = "";
              });
            } else {
              form.setFieldState("AgreementNumber", (state) => {
                state.value = "";
                // 强行覆盖 用feedbacks 非强行覆盖用 errors
                // state.feedbacks = []
                state.required = true;
              });
            }
          });
          //如果ProductType选中Azure且CreateOrderType下单类型为AdditionalOrder追加订单则FirstYearAmount首年合同金额（含税）不可见
          //这里用被动模式去写(多对一)
          onFieldReact("FirstYearAmount", (field) => {
            const ProductType = field.query("ProductType").value();
            const CreateOrderType = field.query("CreateOrderType").value();
            field.hidden =
              ProductType === "Azure" && CreateOrderType === "AdditionalOrder"
                ? true
                : false;
          });

          //CustomerName客户名称，当CreateOrderType=="AdditionalOrder"追加订单时，不能自己输入
          onFieldReact("CustomerName", (field) => {
            const CreateOrderType = field.query("CreateOrderType").value();
            field.disabled =
              CreateOrderType === "AdditionalOrder" ? true : false;
          });

          //如为非标准帐期则显示EPT模板，否则不可见。
          onFieldReact("EptFile", (field) => {
            const CreateOrderType = field.query("CreateOrderType").value();
            const ProductType = field.query("ProductType").value();
            const TotalAmount = field.query("TotalAmount").value();
            const FirstYearAmount = field.query("FirstYearAmount").value();
            const Amount =
              CreateOrderType === "AdditionalOrder" && ProductType === "Azure"
                ? TotalAmount
                : FirstYearAmount;
            const BillingTerm = field.query("BillingTerm").value();
            console.log("CreateOrderType", CreateOrderType);
            console.log("ProductType", ProductType);
            console.log("TotalAmount", TotalAmount);
            console.log("FirstYearAmount", FirstYearAmount);
            console.log("BillingTerm", BillingTerm);
            console.log("Amount", Amount);
            field.visible =
              BillingTerm === "30Days" ||
              (BillingTerm === "45Days" && Amount <= 200000)
                ? false
                : true;
          });
        },
      }),
    []
  );
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <div>
      <Card bordered={false}>
        {partnerNumber && <CreditSummary partnerNumber={partnerNumber} />}
      </Card>
      <Card bordered={false}>
        <Modal
          title="错误提示"
          visible={showErr}
          onOk={() => {
            setShowErr(false);
          }}
          onCancel={() => {
            setShowErr(false);
          }}
        >
          {(() => {
            const data: any = [];
            let i = 0;
            for (const key in errs) {
              i++;
              const err = errs[key];
              data.push({
                key: i,
                keyName: key,
                value: err,
              });
            }
            return (
              <Table
                pagination={false}
                dataSource={data}
                columns={[
                  {
                    title: "字段名称",
                    dataIndex: "keyName",
                    key: "keyName",
                  },
                  {
                    title: "错误描述",
                    dataIndex: "value",
                    key: "value",
                  },
                ]}
              />
            );
          })()}
        </Modal>
        <FormProvider form={form}>
          <Field
            name="PartnerNumber"
            title="合作伙伴编号"
            required
            display="hidden"
            validator={{ maximum: 20 }}
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="PartnerName"
            title="合作伙伴名称"
            required
            display="hidden"
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="CustomerNumber"
            title="客户Number"
            display="hidden"
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <VoidField
            name="CreateOrderType_and_AgreementNumber"
            decorator={[
              FormItem,
              {
                asterisk: true,
                feedbackLayout: "none",
              },
            ]}
            component={[
              Space,
              {
                // style: {
                //     width: 600,
                // },
              },
            ]}
          >
            <Field
              name="CreateOrderType"
              title="下单类型"
              required
              dataSource={datasource.CreateOrderType}
              initialValue="AdditionalOrder"
              decorator={[FormItem]}
              component={[
                Radio.Group,
                {
                  style: {
                    width: 300,
                  },
                },
              ]}
            />

            <Field
              name="AgreementNumber"
              title="合约编号"
              required
              decorator={[FormItem]}
              validator={[{ len: 13 }]}
              component={[
                Input,
                {
                  style: {
                    width: 300,
                  },
                },
              ]}
            />
          </VoidField>

          <VoidField
            name="CustomerName_and_ProductType"
            decorator={[
              FormItem,
              {
                asterisk: true,
                feedbackLayout: "none",
              },
            ]}
            component={[
              Space,
              {
                // style: {
                //     width: 600,
                // },
              },
            ]}
          >
            <Field
              name="CustomerName"
              title="客户名称"
              required
              validator={{ maximum: 100 }}
              decorator={[FormItem]}
              component={[
                Input,
                {
                  style: {
                    width: 300,
                  },
                },
              ]}
            />
            <Field
              name="ProductType"
              title="产品"
              required
              dataSource={datasource.ProductType}
              initialValue={""}
              decorator={[FormItem]}
              component={[
                Select,
                {
                  style: {
                    width: 300,
                  },
                },
              ]}
            />
          </VoidField>

          {/* 这个隐藏掉 */}
          <Field
            name="ContractType"
            title="ContractType"
            required
            display="hidden"
            dataSource={datasource.ContractType}
            initialValue={"Indirect"}
            decorator={[FormItem]}
            component={[
              Select,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <VoidField
            name="FirstYearAmount_and_TotalAmount"
            decorator={[
              FormItem,
              {
                asterisk: true,
                feedbackLayout: "none",
              },
            ]}
            component={[
              Space,
              {
                // style: {
                //     width: 600,
                // },
              },
            ]}
          >
            <Field
              name="FirstYearAmount"
              title="首年合同金额（含税）"
              required
              validator={["number", { maximum: 1000000000 }]}
              decorator={[FormItem]}
              component={[
                NumberPicker,
                {
                  style: {
                    width: 300,
                  },
                },
              ]}
            />

            <Field
              name="TotalAmount"
              title="合同总额（含税）"
              required
              validator={["number", { maximum: 1000000000 }]}
              decorator={[FormItem]}
              component={[
                NumberPicker,
                {
                  style: {
                    width: 300,
                  },
                },
              ]}
            />
          </VoidField>

          <VoidField
            name="BillingTerm_and_PaymentWay"
            decorator={[
              FormItem,
              {
                asterisk: true,
                feedbackLayout: "none",
              },
            ]}
            component={[
              Space,
              {
                // style: {
                //     width: 600,
                // },
              },
            ]}
          >
            <Field
              name="BillingTerm"
              title="账期"
              required
              dataSource={datasource.BillingTerm}
              initialValue={"30Days"}
              decorator={[FormItem]}
              component={[
                Select,
                {
                  style: {
                    width: 300,
                  },
                },
              ]}
            />

            <Field
              name="PaymentWay"
              title="付款周期"
              required
              dataSource={datasource.PaymentWay}
              initialValue={""}
              decorator={[FormItem]}
              component={[
                Select,
                {
                  style: {
                    width: 300,
                  },
                },
              ]}
            />
          </VoidField>

          <Field
            name="Comment"
            title="备注"
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 788,
                },
              },
            ]}
          />

          <Field
            name="EptFile"
            title="EPT"
            decorator={[FormItem]}
            component={[
              ExcelUpload,
              {
                style: {
                  width: 488,
                },
              },
            ]}
          />
          <FormButtonGroup
            style={{
              marginLeft: "180px",
            }}
          >
            <Submit
              disabled={loading}
              onSubmit={(values) => {
                console.log(values);
                post(values);
              }}
            >
              {loading ? "正在提交" : "提交"}
            </Submit>
          </FormButtonGroup>
        </FormProvider>
      </Card>
    </div>
  );
}
